import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslatePipe } from '@ngx-translate/core';
import { LoaderService } from '@services';

@Component({
  imports: [MatProgressSpinner, TranslatePipe],
  selector: 'monitor-ui-loader',
  styleUrls: ['./loader.component.scss'],
  templateUrl: './loader.component.html',
})
export class LoaderComponent implements OnInit, OnDestroy {
  constructor(
    public loaderService: LoaderService,
    private readonly self: ElementRef<LoaderComponent>,
  ) {}

  ngOnDestroy(): void {
    this.loaderService.unregisterLoader(this.self);
  }

  ngOnInit(): void {
    this.loaderService.registerLoader(this.self);
  }
}
